<template>
  <div class="tms-dashboard">
    <div class="content-body">
      <div class="nav-bar-container">
        <div class="nav-bar clearfix">
          <div
            v-if="!isTenant"
            class="welcome"
          >
            <span class="summary-hello">{{ $t("hello") }}</span>
            <span class="summary-name">{{ (currentUserContact || {}).name || currentUser.name }}</span>
          </div>
        </div>
      </div>

      <div class="tenant-dashboard__wrapper">
        <TenancyRecords
          v-if="canReadTenancyRecord"
          :preload="!!tenancyRecords"
          :preloadedTenancies="tenancyRecords || []"
        />
        <HandoverTakeback
          v-if="canReadHotb"
          :preload="!!handoverTakeback"
          :preloadedHotb="handoverTakeback || []"
        />
        <MyTenantProjects
          class="margin-top"
          v-if="canReadProject"
          :preload="!!tenantProjects"
          :preloadedTenantProjects="tenantProjects || []"
        />
        <!-- hotfix HKLDCMS-17266  -->
        <WorkPermits
          v-if="enableWorkPermitsFeature && (canReadProject || canCreateStandalone)"
          :hasAccess="canReadProject || canCreateStandalone"
          :tenancyRecords="tenancyRecords || []"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import MyTenantProjects from '@/modules/dashboards/MyTenantProjects'
import WorkPermits from '@/modules/dashboards/WorkPermits'
import HandoverTakeback from '@/modules/tenants/dashboards/HandoverTakeback'
import TenancyRecords from '@/modules/tenants/dashboards/TenancyRecords'

import EventBus from '@/utils/eventBus'
import i18n from '@/utils/i18n'
import notification from '@/utils/notification'
import router from '@/router'
import { aclHelper, tenantPermsTypes } from '@/utils/aclHelper'
import { getUserTenantPerms } from '@/api/users/request'
import {
  preloadTenancyRecords,
  preloadHandoverTakeback,
  preloadTenantProjects,
  showCreateStandaloneBtn,
  tenantProjectAccess,
  logout,
} from '../services'

export default {
  data () {
    return {
      handoverTakeback: [],
      tenancyRecords: [],
      tenantProjects: [],
      workPermits: [],
      canReadHotb: false,
      canReadProject: false,
      canCreateStandalone: false,
      canReadTenancyRecord: false,
      loadingTenderTable: false,
      tabNames: [
        this.$i18n.t('handoverTakeback'),
        `${this.$i18n.t('tender.general.fitout')} & ${this.$i18n.t('tender.general.reInstatement')}`,
      ],
    }
  },
  components: {
    TenancyRecords,
    HandoverTakeback,
    MyTenantProjects,
    WorkPermits,
  },
  methods: {
    ...mapActions('tenancyRecords', ['loadAllTenancies']),
    showProjectsTable () {
      return this.vendorProjects && this.vendorProjects.length > 0 && aclHelper.hasProjectsAccess(true)
    },
    setData (data) {
      this.tenancyRecords = data.tenancyRecords
      this.handoverTakeback = data.handoverTakeback
      this.tenantProjects = data.tenantProjects
    },
  },
  computed: {
    ...mapGetters('user', ['isTenant', 'currentUser', 'currentUserContact']),
    ...mapGetters('regions', ['enableWorkPermitsFeature', 'enableTenancyRecordsFeature', 'enableTenantProjectsFeature']),
    vendorId () {
      return router.currentRoute.params.id
    },
  },
  async beforeRouteEnter (to, from, next) {
    let preloadData = {}
    // Must follow the order tenancy record=> showCreateStandaloneBtn/ Others
    if (aclHelper.getAccess(tenantPermsTypes.tenancies.readUpdate)) {
      preloadData.tenancyRecords = await preloadTenancyRecords()
      if (preloadData.tenancyRecords.length) {
        return next(vm => vm.setData(preloadData))
      }
    }
    if (await showCreateStandaloneBtn()) {
      return next(vm => vm.setData(preloadData))
    }

    if (aclHelper.getAccess(tenantPermsTypes.hotb.readUpdate)) {
      preloadData.handoverTakeback = await preloadHandoverTakeback()
      if (preloadData.handoverTakeback.length) {
        return next(vm => vm.setData(preloadData))
      }
    }

    const { canReadProject } = await tenantProjectAccess()
    if (canReadProject) {
      preloadData.tenantProjects = await preloadTenantProjects()
      if (preloadData.tenantProjects.length) {
        return next(vm => vm.setData(preloadData))
      }
    }
    logout()
    EventBus.emit('module_loading_stopLoading')
    notification.fireNotification(false, i18n.t('error.invalidLogin'))
    next(false)
  },
  async mounted () {
    const user = await getUserTenantPerms(this.currentUser.id)
    if (this.enableTenantProjectsFeature && user.tenantProjectAccount.length > 0) {
      this.canReadProject = true
    }
    if (user.tenancyContractorAccount.length > 0) {
      this.canCreateStandalone = true
    }
    if (this.enableTenantProjectsFeature && user.roles && aclHelper.hasTmsAccess(tenantPermsTypes.project.readUpdate)) this.canReadProject = true

    if (this.enableTenantProjectsFeature && aclHelper.getAccess(tenantPermsTypes.projectContractor.readUpdate)) this.canReadProject = true
    if (this.enableTenancyRecordsFeature && aclHelper.getAccess(tenantPermsTypes.tenancies.readUpdate)) this.canReadTenancyRecord = true
    if (this.enableTenantProjectsFeature && aclHelper.getAccess(tenantPermsTypes.hotb.readUpdate)) this.canReadHotb = true
  },
}
</script>

<style lang="scss">
@import '~styles/dashboard/tmsdashboard';
</style>
<style lang="scss" scoped>
.margin-top {
  margin-top: 15px;
}
</style>
